// extracted by mini-css-extract-plugin
module.exports = {"comp":"FAQ_comp__bg_Iy"};